/**
 * Hook de conveniencia para usar notificaciones
 * Devuelve directamente el objeto notify para facilitar su uso
 */
import { useContext } from 'react';
import NotificationContext from '../contexts/NotificationContext';

export const useNotification = () => {
  const context = useContext(NotificationContext);
  
  if (!context) {
    throw new Error('useNotification debe usarse dentro de NotificationProvider');
  }
  
  // Devolver directamente el objeto notify para facilitar su uso
  return context.notify;
};

